import { AutocompleteRenderInputParams, IconButton, Stack } from '@mui/material';
import { ChangeEventHandler, useCallback, useRef, useState } from 'react';
import { DynamicIcon, Tooltip } from 'src/components';
import { SidePanelCaption } from 'src/components/SidePanelCaption';
import { FilterResultsTextField } from './filter-results-text-field';

export const SearchBar = ({
  title,
  onChange,
  value,
  setValue,
  params,
  placeholder,
}: {
  title?: string;
  value?: unknown;
  setValue?: React.Dispatch<React.SetStateAction<string>>;
  onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  params?: AutocompleteRenderInputParams;
  placeholder?: string;
}) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const onFilterFieldBlur = useCallback(() => {
    // don't collapse field if it has value
    setIsSearchOpen(!!inputRef.current?.value);
  }, []);

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        width={isSearchOpen ? 0 : '100%'}
        overflow="hidden"
        justifyContent="space-between"
        sx={{
          transition: '0.2s width',
        }}
      >
        {!!title && <SidePanelCaption>{title}</SidePanelCaption>}
        <Tooltip title="Open search bar">
          <IconButton
            sx={{
              display: isSearchOpen ? 'none' : 'flex',
              padding: 0.5,
            }}
            onClick={() => {
              setIsSearchOpen((currentValue) => !currentValue);
              inputRef.current?.focus();
            }}
          >
            <DynamicIcon name="search" filled />
          </IconButton>
        </Tooltip>
      </Stack>
      <FilterResultsTextField
        placeholder={placeholder}
        params={params}
        value={value}
        setValue={setValue}
        inputRef={inputRef}
        isTextFieldOpen={isSearchOpen}
        handleOnChange={onChange}
        onBlur={onFilterFieldBlur}
      />
    </Stack>
  );
};
